import { render, staticRenderFns } from "./127.vue?vue&type=template&id=01032630&scoped=true&"
var script = {}
import style0 from "./127.vue?vue&type=style&index=0&id=01032630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01032630",
  null
  
)

export default component.exports